import styled, { css } from 'styled-components'

const fixedOverlay = css`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1000;
`

export const LoaderOverlay = styled.div`
  ${fixedOverlay};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.45);
`

export const LoaderContainer = styled.div`
  background-color: #f5f5f5;
  border-radius: 16px;
  border: 10px solid rgba(200, 200, 200, 0.5);
`

export const SuperAuthIFrame = styled.iframe<{ isReady?: boolean }>`
  ${fixedOverlay};
  ${({ isReady }) =>
    !isReady
      ? css`
          display: none;
        `
      : css``}
`
